import { useState } from "react";
import "./MovieCard.css";

export default function MovieCard({ movie }) {
  const { title, description, posterURL, rating } = movie;
  const [imgError, setImgError] = useState(false);

  // Star rendering
  const stars = Array.from({ length: 5 }, (_, i) => {
    const filled = rating / 2 >= i + 1;
    const half   = !filled && rating / 2 >= i + 0.5;
    return (
      <span key={i} className={`star ${filled ? "star--on" : half ? "star--half" : ""}`}>
        ★
      </span>
    );
  });

  const ratingColor =
    rating >= 8.5 ? "#52c87a" : rating >= 7 ? "#e8b84b" : "#e05c5c";

  return (
    <article className="card">
      {/* Poster */}
      <div className="card__poster">
        {!imgError ? (
          <img
            src={posterURL}
            alt={title}
            className="card__img"
            onError={() => setImgError(true)}
          />
        ) : (
          <div className="card__img-fallback">
            <span>🎬</span>
          </div>
        )}
        {/* Rating badge */}
        <div className="card__badge" style={{ "--color": ratingColor }}>
          {rating.toFixed(1)}
        </div>
        {/* Hover overlay */}
        <div className="card__overlay">
          <p className="card__desc">{description}</p>
        </div>
      </div>

      {/* Info */}
      <div className="card__info">
        <h3 className="card__title">{title}</h3>
        <div className="card__stars">{stars}</div>
      </div>
    </article>
  );
}